<div class="promo-tile-outer-container">
  <div class="promo-tile-container" *ngFor="let item of promoContentData; let i = index">
    <div class="promo-tile-body" *ngIf="!(item?.linkedAssetFileType.includes('video') && item?.fullScreenCheckbox)"
      [ngStyle]="setBgStyle(item)">
      <div class="promo-text-container-center" [ngClass]="setIntelDisplayOneFont ? 'intelOne-display':''">
        <span *ngIf="item?.title" class="promo-title-center promo-title" [innerHTML]="item?.title"></span>
        <div *ngIf="item?.linkedAssetFileType.includes('image')" class="img-container-center-aligned"
          [ngClass]="!item?.bodyCopy ? 'remove-extra-margin' :''">
          <img id="promoImage" [src]="(assetsUrl + item?.pageNum)" alt="promo-img-mid" (load)="onImageLoad(i)"
            (error)="onImageError(i)" />
          <div class="loader_outer" *ngIf="isImageLoading(i)">
            <span class="loader"></span>
          </div>
        </div>
        <div class="video-container-center-aligned" *ngIf="item?.linkedAssetFileType.includes('video')">
          <video class="promo-video" playsinline webkit-playsinline disablePictureInPicture disableRemotePlayback
            controlsList="noplaybackrate noaudio nodownload nofullscreen" [muted]="true" preload="auto"
            (loadstart)="onVideoLoadStart(videoPlayerContainer)" (canplay)="onVideoCanPlay(videoPlayerContainer)"
            (playing)="onVideoPlaying(videoPlayerContainer)" (waiting)="onVideoWaiting(videoPlayerContainer)"
            (play)="onPlayVideo(videoPlayerContainer)" (pause)="onPauseVideo(videoPlayerContainer)"
            (ended)="onVideoEnded(videoPlayerContainer)" (click)="toggleVideo(videoPlayerContainer)"
            #videoPlayerContainer>
            <source [src]="(assetsUrl + item?.pageNum)" type="video/mp4">
          </video>
          <div *ngIf="isVideoLoading(videoPlayerContainer)" class="loader_outer">
            <span class="loader"></span>
          </div>
          <img src="assets/images/promo-play-pause-icon.svg" class="play-pause-icon" #playPauseIcon
            *ngIf="!isVideoPlaying(videoPlayerContainer) && !isVideoLoading(videoPlayerContainer)" (click)="toggleVideo(videoPlayerContainer)" alt="play-Icon" />
        </div>
        <span *ngIf="item?.bodyCopy" class="promo-body" [innerHTML]="item?.bodyCopy | sanitizeHtml"></span>
      </div>
    </div>
    <div class="promo-tile-body-full-screen"
      *ngIf="item?.linkedAssetFileType.includes('video') && item?.fullScreenCheckbox" [ngStyle]="setBgStyle(item)">
      <video class="promo-video-full-screen" playsinline webkit-playsinline disablePictureInPicture
        disableRemotePlayback controlsList="noplaybackrate noaudio nodownload nofullscreen" [muted]="true"
        preload="auto" (loadstart)="onVideoLoadStart(videoPlayerContainer)"
        (canplay)="onVideoCanPlay(videoPlayerContainer)" (playing)="onVideoPlaying(videoPlayerContainer)"
        (waiting)="onVideoWaiting(videoPlayerContainer)" (play)="onPlayVideo(videoPlayerContainer)"
        (pause)="onPauseVideo(videoPlayerContainer)" (ended)="onVideoEnded(videoPlayerContainer)"
        (click)="toggleVideo(videoPlayerContainer)" #videoPlayerContainer>
        <source [src]="(assetsUrl + item?.pageNum)" type="video/mp4">
      </video>
      <div *ngIf="isVideoLoading(videoPlayerContainer)" class="loader_outer">
        <span class="loader"></span>
      </div>
      <img src="assets/images/promo-play-pause-icon.svg" class="play-pause-icon" #playPauseIcon
        *ngIf="!isVideoPlaying(videoPlayerContainer) && !isVideoLoading(videoPlayerContainer)" (click)="toggleVideo(videoPlayerContainer)" alt="play-Icon" />
    </div>
  </div>
</div>
<button class="compare-button" [routerLink]="[]" [queryParams]="{ activeTab: 'compare' }" (click)="onCompareClick()" [ngClass]="{'ptl-std-compare-button': isPantherLakeStd,'wildCatLakeStd-btn':iswildCatLakeStd, 'ptl-gaming-compare-button': isPantherLakeGaming, 'intelOne-display': setIntelDisplayOneFont}" type="button" aria-label="Compare this device">
  <span class="compare-icon" aria-hidden="true">
    <img src="assets/images/compare-btn-icon.svg" alt="compare-btn-icon">
  </span>
  <span class="compare-text" [innerHTML]="compareButtonText"></span>
</button>
